import type { Inquiry } from '../types';

// APIから取得したと仮定するダミーデータ
export const allInquiries: Inquiry[] = [
    {
      id: '1',
      status: '受付済',
      requestDate: '2025/08/01 10:00',
      visitDate: '日程調整中',
      equipmentName: '洗面台',
      plan: '水漏れプラン',
      amount: '5,500円',
      symptomLocations: [
        { symptom: '水漏れ', location: '洗面所' }
      ],
      contractor: 'Jun Corporation',
      receptionManager: '受付 太郎',
      manager: '受付 太郎'
    },
    {
        id: '2',
        status: '訪問確定済',
        requestDate: '2025/08/02 11:00',
        visitDate: '2025/08/10 13:00',
        equipmentName: 'トイレ',
        plan: '詰まり除去プラン',
        amount: '8,800円',
        symptomLocations: [
          { symptom: 'トイレの詰まり', location: 'トイレ' },
          { symptom: '排水の遅れ', location: '洗面所' }
        ],
        contractor: 'Jun Corporation',
        receptionManager: '受付 太郎',
        manager: '作業 員一'
    },
    {
      id: '4',
      status: '調査見積もり済',
      requestDate: '2025/08/04 13:00',
      visitDate: '2025/08/15 14:00',
      equipmentName: 'シャワー',
      symptomLocations: [
        { symptom: 'シャワーの故障', location: '浴室' }
      ],
      processedSystem: 'home-karte',
    },
    {
      id: '5',
      status: '見積もりサイン済',
      requestDate: '2025/08/05 14:00',
      visitDate: '2025/08/20 09:00',
      equipmentName: 'シャワー',
      symptomLocations: [
        { symptom: 'シャワーの故障', location: '浴室' }
      ],
    },
    {
      id: '6',
      status: '作業報告書確認',
      requestDate: '2025/08/06 15:00',
      visitDate: '2025/08/22 11:00',
      equipmentName: '換気扇',
      symptomLocations: [
        { symptom: '換気扇の異音', location: 'キッチン' }
      ],
      processedSystem: 'home-karte',
    },
    {
      id: '7',
      status: '作業完了',
      requestDate: '2025/08/08 17:00',
      visitDate: '2025/08/28 16:00',
      equipmentName: '外壁',
      symptomLocations: [
        { symptom: '外壁のひび割れ', location: '外壁' }
      ],
      paymentMethod: 'invoice'
    },
    {
      id: '8',
      status: '作業完了',
      requestDate: '2025/08/09 18:00',
      visitDate: '2025/08/30 10:00',
      equipmentName: 'コンセント',
      symptomLocations: [
        { symptom: 'コンセントの増設', location: 'リビング' },
        { symptom: '照明スイッチ交換', location: '寝室' }
      ],
      paymentMethod: 'cash'
    },
];
